import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { DarkTheme5_1 } from "../DarkTheme5_1";
export var DarkTheme5_2 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_2() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_2, _BasicThemeClassForEx);
    return _createClass(DarkTheme5_2, null, [{
      key: "mobileModalCloseButtonRightPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileModalCloseButtonTopPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }]);
  }(BasicThemeClassForExtension), _DarkTheme5_.kebabBackgroundHover = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.kebabBackgroundActive = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.mobileModalCloseButtonClickArea = '22px', _DarkTheme5_.mobileModalBodyPadding = '0 16px 0 16px', _DarkTheme5_.mobileModalContainerMarginTop = '16px', _DarkTheme5_.mobileModalContainerMarginRight = '16px', _DarkTheme5_.mobileModalContainerMarginBottom = '16px', _DarkTheme5_.mobileModalContainerMarginLeft = '16px', _DarkTheme5_.miniModalMarginTopMobile = '16px', _DarkTheme5_.miniModalMarginLeftMobile = '16px', _DarkTheme5_.miniModalMarginRightMobile = '16px', _DarkTheme5_),
  prototypeTheme: DarkTheme5_1,
  themeMarkers: [markThemeVersion('5.2')]
});